<div class="" fxLayout="column" fxLayoutAlign="start stretch">


  <ng-container *ngIf="!creandoEncuesta">
    <ng-container *ngIf="seccionEncuesta">
      <div *ngIf="procesoFinalizado && procesoOK; else procFallido;" class="" fxLayout="row" fxLayoutAlign="space-evenly center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div class="roundEdg done mat-elevation-z4 pr-20 pl-20 m-10" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'SHEDULE2_0.ENCUESTACREADA' | translate}}</h2>
          <mat-icon class="ml-20 s-30">check_circle</mat-icon>
        </div>
        <button mat-raised-button color="primary" class="wsn done" (click)="verSeccionesAgregadas()">
          {{'SHEDULE2_0.VERSECCIONES' | translate}}
          <mat-icon class="ml-20">format_list_numbered</mat-icon>
        </button>

        <button mat-raised-button color="primary" class="wsn done" (click)="surveyCheckService()">
        {{'SHEDULE2_0.CARDS.PASO5.TITULO' | translate}}
          <mat-icon class="ml-20">check_circle</mat-icon>
        </button>
      </div>
      <ng-template #procFallido>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <div class="roundEdg fail mat-elevation-z4 pr-20 pl-20 m-10" fxLayout="row" fxLayoutAlign="space-between center">
            <h2>{{'SHEDULE2_0.ENCUESTAERROR' | translate}}</h2>
            <mat-icon class="ml-20 s-30">close</mat-icon>
          </div>
          <button mat-raised-button color="primary" class="wsn done" (click)="verSeccionesAgregadas()">
            {{'SHEDULE2_0.VERSECCIONES' | translate}}
            <mat-icon class="ml-20">format_list_numbered</mat-icon>
          </button>
        </div>
      </ng-template>
    </ng-container>
    <div fxLayout="row wrap" fxLayoutAlign="space-evenly start" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
      <div *ngFor="let card of cards; let i = index;" class="course-content m-20" fxLayout="column" fxFlex="100" fxFlex.gt-xs="40" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
          <div class="category" fxFlex>
            {{card.titulo | translate}}
          </div>
        </div>
        <div class="content m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">

          <ng-container *ngIf="i == 0">
            <ng-container *ngIf="card.completo == false; else card1Ok">
              <!-- <p>Necesita aceptar los requerimientos técnicos para programar la encuesta</p> -->
              <p>{{'SHEDULE2_0.CARDS.PASO1.INFO_PRE' | translate}}</p>
              <mat-list>
                <mat-list-item>
                  <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.REQTEC' | translate}}</p>
                  <button *ngIf="!reqTecOK" mat-mini-fab color="accent" routerLink="/requirements-detail" matTooltip="{{'SHEDULE2_0.CARDS.PASO1.REQTEC_TOOLTIP' | translate}}" matTooltipPosition="right">
                    <mat-icon>send</mat-icon>
                  </button>
                  <div *ngIf="reqTecOK" class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <mat-icon class="s-20">done</mat-icon>
                  </div>
                  <mat-divider></mat-divider>
                </mat-list-item>
                <mat-list-item>
                  <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.LOGO' | translate}}</p>
                  <button *ngIf="!logoOK" mat-mini-fab color="accent" matTooltip="{{'SHEDULE2_0.CARDS.PASO1.LOGO_TOOLTIP' | translate}}" matTooltipPosition="right" (click)="cargaLogoEmpresa()">
                    <mat-icon>add_a_photo</mat-icon>
                  </button>
                  <div *ngIf="logoOK" class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <mat-icon class="s-20">done</mat-icon>
                  </div>
                </mat-list-item>
              </mat-list>
              <!-- <button mat-raised-button color="accent" routerLink="/requirements-detail">
                Ir allá
                <mat-icon class="ml-20">send</mat-icon>
              </button> -->
            </ng-container>
            <ng-template #card1Ok>
              <p>{{'SHEDULE2_0.CARDS.PASO1.INFO_POST' | translate}}</p>
              <mat-list>
                <mat-list-item>
                  <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.REQTEC' | translate}}</p>
                  <div class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <mat-icon class="s-20">done</mat-icon>
                  </div>
                  <mat-divider></mat-divider>
                </mat-list-item>
                <mat-list-item>
                  <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.LOGO' | translate}}</p>
                  <div class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <mat-icon class="s-20">done</mat-icon>
                  </div>
                </mat-list-item>
              </mat-list>
            </ng-template>
          </ng-container>

        </div>
        <div class="footer" fxLayout="row" fxLayoutAlign="space-between center">
          <ng-container *ngIf="card.completo == false">
            <div class="h4 secondary-text"><b>{{'SHEDULE2_0.CARDS.STATUS.PENDING' | translate}}</b></div>
            <div class="roundEdg undone mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
              <mat-icon class="s-20">priority_high</mat-icon>
            </div>
          </ng-container>
          <ng-container *ngIf="card.completo == true">
            <div class="h4 secondary-text"><b>{{'SHEDULE2_0.CARDS.STATUS.OK' | translate}}</b></div>
            <div class="roundEdg done mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
              <mat-icon class="s-20">done</mat-icon>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!pasoCompleto">
      <button mat-raised-button color="primary" class="wsn" (click)="preCrearEncuesta()">
        <ng-container *ngIf="recrearEncuesta; else botCrear;">
          {{'SHEDULE2_0.RECREAR' | translate}}
        </ng-container>
        <ng-template #botCrear>
          {{'SHEDULE2_0.CREAR' | translate}}
        </ng-template>
        <mat-icon class="ml-20">play_arrow</mat-icon>
      </button>
    </ng-container>
  </ng-container>


  <div *ngIf="creandoEncuesta" class="tac" fxLayout="column" fxLayoutAlign="start stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
    <div *ngIf="procesoFinalizado || recrearEncuesta" fxLayout="row" fxLayoutAlign="start center" class="mt-20">
      <button mat-raised-button color="accent" (click)="verSeccionesAgregadas()">
        <mat-icon class="mr-20">arrow_back</mat-icon>
        {{'SHEDULE2_0.BACK' | translate}}
      </button>
    </div>
    <h3 *ngIf="!procesoFinalizado && !procesoOK" class="mb-20">{{'SHEDULE2_0.CREANDO' | translate}}</h3>
    <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
      <ng-container *ngFor="let seccion of secciones">
        <div *ngIf="seccion.visible" fxFlex="{{tamanioTagSecc}}" fxLayout="column" fxLayoutAlign="space-between center">
          <!-- <div class="roundEdg iconoSeccion mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center"> -->
          <div class="p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
            <mat-icon class="s-30">{{seccion.icono}}</mat-icon>
          </div>
          <b>{{seccion.titulo | translate}}</b>
          <div *ngIf="!seccion.completo && !seccion.fallo" class="roundEdg undone mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
            <mat-icon class="s-20">more_horiz</mat-icon>
          </div>
          <div *ngIf="seccion.completo" class="roundEdg done mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <mat-icon class="s-20">done</mat-icon>
          </div>
          <div *ngIf="!seccion.completo && seccion.fallo" class="roundEdg fail mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <mat-icon class="s-20">close</mat-icon>
          </div>
        </div>
      </ng-container>
    </div>
    <mat-progress-bar mode="buffer" value="{{progresoEncuesta}}"></mat-progress-bar>
    <h3 *ngIf="procesoActual!= ''" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}"><b>{{procesoActual | translate}}</b></h3>
    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="checarEncuesta">
    <button mat-raised-button color="primary" class="wsn done" (click)="surveyCheckService()" style="width:30%;">
    {{'SHEDULE2_0.CARDS.PASO5.TITULO' | translate}}
      <mat-icon class="ml-20">check_circle</mat-icon>
    </button>
    </div>
    <!-- <div *ngIf="procesoFinalizado && !procesoOK" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'500ms', y:'25px'}}">
      <button mat-raised-button color="accent" class="wsn" (click)="crearEncuesta()">
        {{'SHEDULE2_0.RETRY' | translate}}
        <mat-icon class="ml-20">replay</mat-icon>
      </button>
    </div> -->
  </div>

</div>
<!-- <div *ngIf="procesoFinalizado && procesoOK" fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
  <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'SHEDULE.COMPLETAR_PASO' | translate}}" matTooltipPosition="left" class="undone mr-20">
    <mat-icon>done</mat-icon>
  </button>
  <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
    {{'SHEDULE.PASO_COMPLETADO' | translate}}
    <mat-icon class="ml-20">done</mat-icon>
  </button>
</div> -->
